module.exports = __webpack_public_path__ + "img/68.72d25666.jpg";